module.exports = __webpack_public_path__ + "img/Labelling.cc2de2dd.png";